import CommonVideo from '../../../common/common_video';

export default function ProgramVodView(props) {
  const { mode, isRadioPlay, setIsRadioPlay } = props;

  return (
    <div id="CommonProgramVodView" className="commonProgramVodView" style={{ width: '1280px', margin: '0 auto' }}>
      <CommonVideo mode={mode} isRadioPlay={isRadioPlay} setIsRadioPlay={setIsRadioPlay} />
    </div>
  );
}
